import type { CreatedWithinType } from '../filterTypes';

const CREATED_WITHIN_TO_HOURS: Record<CreatedWithinType, number> = {
  hour: 1,
  day: 24,
  week: 168,
  month: 720,
};

/**
 * Converts createdWithin type to API hours string.
 * 'day' → "24"
 * null → undefined (omit param)
 */
export function createdWithinToApiHours(value: CreatedWithinType | null): string | undefined {
  if (value === null) return undefined;
  return String(CREATED_WITHIN_TO_HOURS[value]);
}
